import { render } from "./SmallTaskSingle.vue?vue&type=template&id=0323903e&scoped=true"
import script from "./SmallTaskSingle.vue?vue&type=script&lang=js"
export * from "./SmallTaskSingle.vue?vue&type=script&lang=js"

import "./SmallTaskSingle.vue?vue&type=style&index=0&id=0323903e&scoped=true&lang=scss"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0323903e"]])

export default __exports__